var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NuxtLink',{attrs:{"to":_vm.linkPath}},[_c('img',{staticClass:"header-image",attrs:{"src":require(("~/assets/images/project/header/" + _vm.recruitmentLargeJobCategoryId + "/list-pattern" + _vm.headerImagePatternNo + ".svg"))}})])}
var staticRenderFns = []

export { render, staticRenderFns }